import { observable } from "mobx";
import AccountingDocumentSearchPermissibility from "./accountingDocumentSearchPermissibility";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SubLedgerReportPreviewResponse {
  @observable
  permissibility!: AccountingDocumentSearchPermissibility;

  @observable
  includedRows?: number;
}
